export function _await_value(value) {
    this.wrapped = value;
}
export { _await_value as _ };
